import { JsonElementType, JsonObject, JsonProperty, JsonType } from "ta-json";

import type { Nullable } from "../../base-types";
import { EntityResource } from "../entity-resource";
import Resource from "../resource";
import { IEntityResourceContainer } from "../resource-containers/entity-resource-container";
import { AggregationResponseResource } from "./aggregation-response-resource";
import { FacetResponseResource } from "./facet-response-resource";
import { FieldFilterResponseResource } from "./field-filter-response-resource";
import { FullTextResponseResource } from "./full-text-response-resource";
import { GroupedViewResponseResource } from "./grouped-view-response-resource";
import { SortingResponseResource } from "./sorting-response-resource";
import { VisualSearchResponseResource } from "./visual-search-response-resource";

interface ISearchResponse extends IEntityResourceContainer {
    getFieldFiltersResources: () => Array<FieldFilterResponseResource>;
    getFullTextFilterResources: () => Array<FullTextResponseResource>;
    getFacetResources: () => Array<FacetResponseResource>;
}

@JsonObject()
export class SearchResponse extends Resource implements ISearchResponse {
    // #region Properties

    @JsonProperty("query")
    query: string;

    @JsonProperty("skip")
    skip: number;

    @JsonProperty("take")
    take: number;

    @JsonProperty("totalItemCount")
    totalItemCount: number;

    @JsonProperty("returnedItemCount")
    returnedItemCount: number;

    @JsonProperty("sorting")
    sorting: SortingResponseResource;

    @JsonProperty("sortingOptions")
    @JsonElementType(SortingResponseResource)
    sortingOptions: Array<SortingResponseResource> = [];

    @JsonProperty("filters")
    @JsonElementType(FieldFilterResponseResource)
    fieldFilters: Array<FieldFilterResponseResource> = [];

    @JsonProperty("fulltext")
    @JsonElementType(FullTextResponseResource)
    fullTextFilters: Array<FullTextResponseResource> = [];

    @JsonProperty("facets")
    @JsonElementType(FacetResponseResource)
    facets: Array<FacetResponseResource> = [];

    @JsonProperty("clearFilters")
    clearFilters: string;

    @JsonProperty("items")
    @JsonElementType(EntityResource)
    items: Array<EntityResource> = [];

    @JsonProperty("superfacet")
    superFacet?: number;

    @JsonProperty("aggregations")
    @JsonType(AggregationResponseResource)
    aggregations?: Nullable<AggregationResponseResource>;

    @JsonProperty("grouped_view")
    @JsonType(GroupedViewResponseResource)
    groupedView?: Nullable<GroupedViewResponseResource>;

    @JsonProperty("visualSearch")
    visualSearch?: VisualSearchResponseResource;

    //? ExtensionData

    // #endregion

    // #region Methods

    getEntityResources(): Array<EntityResource> {
        if (this.groupedView != null) {
            return this.groupedView.getEntityResources();
        }

        return this.items;
    }

    getFieldFiltersResources(): Array<FieldFilterResponseResource> {
        return this.fieldFilters;
    }

    getFullTextFilterResources(): Array<FullTextResponseResource> {
        return this.fullTextFilters;
    }

    getFacetResources(): Array<FacetResponseResource> {
        return this.facets;
    }

    // #endregion
}
